import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerService, LookupService } from '../../../services/models';
import { BaseListComponent } from '../../base/base.list.component';

@Component({
  templateUrl: './customer.component.html'
})

export class CustomerComponent extends BaseListComponent implements OnInit {
  campaignTitles: string[];
  campaign_id: number;
  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private lookupService: LookupService,
    protected injector: Injector,
  ) {
    super(customerService, injector, 'customers');
    let id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.record_id = id;
      this.mode = 'edit';
    }

    this.campaignTitles = [];

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 25,
      ajax: this.getAjaxConfig('customers'),
      order: [[8, "desc"]],
      "columns": [
        {
          data: "name",
          title: "Full Name"
        },
        {
          data: "address",
          title: "Address"
        },
        {
          data: "phone",
          title: "Phone"
        },
        {
          data: "email",
          title: "Email"
        },
        {
          data: "proof_purchase",
          title: "Image",
          visible: false
        },
        {
          data: "campaign_title",
          title: "Campaign Title"
        },
        {
          data: "question_title",
          title: "Question Title"
        },
        {
          data: "questions",
          title: "Questions"
        },
        {
          data: "opt_in",
          title: "Opt In"
        },
        {
          data: "created_at",
          title: "Created At"
        },

        {
          data: "updated_at",
          title: "Updated At",
          visible: false
        },
        {
          data: "id",
          title: "ID",
          visible: false
        },
        {
          title: 'Action',
          orderable: false,
          render: function (data: any, type: any, full: any) {
            return '<a edit-record-id="' + full.id + '" class="btn btn-primary">Show</a>&nbsp;&nbsp;<a delete-record-id="' + full.id + '" class="btn btn-danger">Delete</a>';
          }
        }
      ]
    }
  }

  ngOnInit() {

    this.lookupService.getAll("campaigns-list")
      .subscribe(
        data => {
          this.campaignTitles = data.data;
          console.log(data.data);
        },
        error => {
          console.log(error);
        });

    this.campaign_id = 0;
  }

  ngAfterViewInit(): void {
    this.bindListeners();
  }

  ngOnDestroy() {
    this.clearListeners();
  }

  addRecord() {
    this.record_id = 'new';
    this.mode = 'edit';
  }

  downloadEntries(campaignId) {
    if (campaignId > 0) {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '/entry_download/' + campaignId);
      link.setAttribute('download', 'entries_' + campaignId + '.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      alert("Please select a campaign to export");
    }
  }

  checkValue() {
    return this.campaign_id > 0 ? true : false;
  }
}
